import MainRoute from './MainRoutes';
export default MainRoute;


// WEBPACK FOOTER //
// ./src/routes/index.ts